<template>
  <v-menu>
    <template #activator="{ props }">
      <v-tooltip text="Actions" location="top">
        <template #activator="{ props: tooltipProps }">
          <v-btn
            v-bind="{ ...props, ...tooltipProps }"
            icon
            size="small"
            variant="text"
            aria-label="Row actions"
            :disabled="disabled"
            class="row-actions-menu__trigger"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </template>

    <v-list density="compact" class="row-actions-menu__list">
      <v-list-subheader class="row-actions-menu__subheader">Set status</v-list-subheader>

      <v-list-item
        v-for="statusOption in statusOptions"
        :key="statusOption.value"
        data-test="row-actions-menu-status-option"
        :class="{ 'row-actions-menu__item--current': currentStatus === statusOption.value }"
        @click="onSetStatus(statusOption.value)"
      >
        <template #prepend>
          <span class="row-actions-menu__dot" :style="{ background: statusOption.color }"></span>
        </template>
        <v-list-item-title>{{ statusOption.label }}</v-list-item-title>
        <template v-if="currentStatus === statusOption.value" #append>
          <v-icon size="small" color="primary">mdi-check</v-icon>
        </template>
      </v-list-item>

      <template v-if="canReupload">
        <v-divider class="my-1" />
        <v-list-item data-test="row-actions-menu-reupload" @click="onReupload">
          <template #prepend>
            <v-icon size="small" class="row-actions-menu__icon" aria-hidden="true"
              >mdi-upload</v-icon
            >
          </template>
          <v-list-item-title>Re-upload corrected CSVs</v-list-item-title>
        </v-list-item>
      </template>

      <template v-if="canCancel">
        <v-divider class="my-1 row-actions-menu__divider--strong" />
        <v-list-item
          data-test="row-actions-menu-cancel"
          class="row-actions-menu__item--cancel"
          @click="onCancel"
        >
          <template #prepend>
            <v-icon size="small" class="row-actions-menu__icon" aria-hidden="true"
              >mdi-cancel</v-icon
            >
          </template>
          <v-list-item-title>Cancel batch</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import batchStatus, { batchStatusConfig, journeyStatusOrder } from '../../lib/const/batchStatus';

export default {
  name: 'RowActionsMenu',

  props: {
    currentStatus: {
      type: String,
      required: true,
      validator: (val) => Object.values(batchStatus).includes(val)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:status', 'reupload', 'cancel'],

  computed: {
    statusOptions() {
      return journeyStatusOrder.map((status) => ({
        value: status,
        label: batchStatusConfig[status].label,
        color: batchStatusConfig[status].textColor
      }));
    },
    canReupload() {
      return this.currentStatus === batchStatus.FAILED;
    },
    canCancel() {
      return this.currentStatus !== batchStatus.CANCELLED;
    }
  },

  methods: {
    onSetStatus(status) {
      this.$emit('update:status', status);
    },
    onReupload() {
      this.$emit('reupload');
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.row-actions-menu__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  flex-shrink: 0;
}

.row-actions-menu__subheader {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 500;
}

.row-actions-menu__item--current {
  font-weight: 500;
}

.row-actions-menu__item--cancel :deep(.v-list-item-title) {
  color: #c25461;
  font-weight: 500;
}

.row-actions-menu__divider--strong {
  border-color: #d8d3c5;
}

.row-actions-menu__list {
  min-width: 260px;
}

.row-actions-menu__icon {
  margin-right: 8px;
  flex-shrink: 0;
}
</style>
